import React, { useState } from 'react';

import postFeedback from './api';
import WorkflowSteps from './WorkflowSteps';
import FeedbackReasonModal from './FeedbackReasonModal';
import './styles.sass';

// Component
const FeedbackWorkflow = ({ postType, researchOutputId, postId, postUrl, sentimentScore }) => {
  // Response helper
  const submitFeedback = ({ feedbackRating = null, feedbackReason = null }) => {
    if (feedbackReason !== null) {
      Analytics.trackEvent(`Sentiment Feedback: Feedback-Reason submitted`, {});
    } else if (feedbackRating !== null) {
      Analytics.trackEvent('Sentiment Feedback:  Feedback-Rating submitted', { feedbackRating });
    }

    const body = {
      sentiment_feedback: {
        source: 'explorer',
        post_type: postType,
        research_output_id: researchOutputId,
        post_id: postId,
        post_url: postUrl,
        sentiment_score: sentimentScore,
        feedback_rating: feedbackRating,
        feedback_reason: feedbackReason
      }
    };
    postFeedback(body).then(stepForwards).catch(setError);
  };

  // Workflow definition
  const workflowSteps = ['initial', 'promptForReason', 'showReasonForm', 'feedbackSubmitted'];
  const [currentStep, setStep] = useState(0);
  const [error, setError] = useState(null);

  const stepForwards = () => setStep(currentStep + 1);
  const stepBackwards = () => setStep(currentStep - 1);

  const Body = () => {
    switch (workflowSteps[currentStep]) {
      case 'initial':
        return <WorkflowSteps.InitialState submitFeedback={submitFeedback} />;
      case 'promptForReason':
        return (
          <>
            <WorkflowSteps.ThankYou />
            <WorkflowSteps.AskWhy onClick={stepForwards} />
          </>
        );
      case 'showReasonForm':
        return (
          <FeedbackReasonModal
            onSubmit={(feedbackReason) => submitFeedback({ feedbackReason })}
            onCancel={stepBackwards}
          />
        );
      case 'feedbackSubmitted':
        return <WorkflowSteps.ThankYou />;
      default:
        throw new Error(`Unexpected workflow step: ${currentStep} (resolved to ${workflowSteps[currentStep]})`);
    }
  };

  return (
    <div className="Mentions-Output-Sentiment-FeedbackForm">
      <div className="sentiment-feedback-workflow-container">
        {error ? <p>Error sending feedback, please try again later.</p> : <Body />}
      </div>
    </div>
  );
};

export default FeedbackWorkflow;
